import { useState } from 'react'
import { Link as RouterLink } from 'react-router'

import Button from '@mui/material/Button'
import CardActionArea from '@mui/material/CardActionArea'
import Snackbar from '@mui/material/Snackbar'
import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import usePubSub, { PubSubEvents } from '@shared/hooks/src/usePubSub'

import Avatar from '@components/Avatar'

import { styles, Title } from '../Notifications.utils'

/**
 * Handle the display of any reminder notifications
 */
export default function ReminderNotifications() {
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState(null)

  const handleClose = () => setOpen(false)

  usePubSub(PubSubEvents.ReminderNotification, (content) => {
    setContent(content)
    setOpen(true)
  })

  return (
    <Snackbar
      open={open}
      onClose={(event, reason) => {
        if (reason === 'escapeKeyDown') handleClose()
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <CardActionArea
        component={content?.action ? RouterLink : undefined}
        to={content?.action?.path}
        onClick={handleClose}
        sx={styles.container}
      >
        <Stack spacing={1}>
          <Title label={content?.title} onClose={handleClose} />
          <Stack spacing={2}>
            <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
              <Avatar.Company size="sm" />
              <Typography>{content?.description}</Typography>
            </Stack>
          </Stack>
          {content?.action && (
            <Stack direction="row" sx={{ justifyContent: 'flex-end' }}>
              <Button color="default">{content?.action?.label}</Button>
            </Stack>
          )}
        </Stack>
      </CardActionArea>
    </Snackbar>
  )
}
